/**
 * Lightweight telemetry helper. Fire-and-forget — never throws, never shows
 * error toasts. Used by Layout.js and Settings.js for the weekly usage audit.
 */
import api from './api';

export const trackEvent = (type, key, value) => {
  try {
    if (!type || !key) return;
    api.silentRequest({
      method: 'POST',
      url: '/audit/telemetry/event',
      data: { type, key, value: value || null },
    }).catch(() => { /* swallow */ });
  } catch { /* swallow */ }
};
